// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Copy } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconCopy(props: any) {
    return <IconBase icon={Copy} {...props} />
  }

  export default IconCopy
  